import {useAppSelector} from "../redux/hooks";
import {RootState} from "../redux/store";

export const LoadingScreen = (props: {}) => {
    const content = useAppSelector((state: RootState) => state.content)

    return (
        <div className='spinner'>
            <span>{content.loadingText != ''? content.loadingText : 'Daten werden geladen...'}</span>
            <div className='half-spinner'></div>
        </div>
    )
}